const pdfView = {
  pdfData: null,
  isLoading: false,
  isModalOpen: false,
}

const PdfViewReducer = function (state = pdfView, action) {
  switch (action.type) {
    case 'PDF_VIEW_LOADING': {
      return {
        ...state,
        isLoading: action.value,
      }
    }
    case 'SET_PDF_VIEW_DATA': {
      return {
        ...state,
        pdfData: action.value,
      }
    }
    case 'TOGGLE_PDF_VIEW_MODAL': {
      return {
        ...state,
        isModalOpen: action.value,
      }
    }
    default: {
      return state
    }
  }
}

export default PdfViewReducer
